export default class Privacy {
  constructor() {
    this.privacyButton = $("#privacy-settings")
    this.cookieBanner = $("cookie-banner")

    if (this.privacyButton.length && this.cookieBanner.length) {
      this.privacyButton.on("click", () => {
        this.cookieBanner[0].promptForConsent()
      })
    }
  }
}
